import { render, staticRenderFns } from "./ModalCreatePerson.vue?vue&type=template&id=9175c13e&scoped=true"
import script from "./ModalCreatePerson.vue?vue&type=script&lang=js"
export * from "./ModalCreatePerson.vue?vue&type=script&lang=js"
import style0 from "./ModalCreatePerson.vue?vue&type=style&index=0&id=9175c13e&prod&scoped=true&lang=scss"
import style1 from "./ModalCreatePerson.vue?vue&type=style&index=1&id=9175c13e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9175c13e",
  null
  
)

export default component.exports